var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConflict(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M698.181818 232.727273V93.090909H93.090909v605.090909h139.636364V232.727273h465.454545z m93.090909 93.090909v465.454545H325.818182v139.636364h605.090909V325.818182h-139.636364z m0-93.090909h232.727273v791.272727H232.727273V791.272727H0V0h791.272727v232.727273z m-465.454545 93.090909v372.363636h372.363636V325.818182H325.818182z m186.181818 46.545454a46.545455 46.545455 0 0 1 46.545455 46.545455v69.818182a46.545455 46.545455 0 0 1-93.09091 0v-69.818182a46.545455 46.545455 0 0 1 46.545455-46.545455z m-0.325818 186.181819c13.940364 0 25.134545 4.328727 33.582545 13.032727 8.843636 8.238545 13.288727 19.316364 13.288728 33.186909 0 13.451636-4.421818 24.738909-13.288728 33.861818a48.872727 48.872727 0 0 1-33.582545 13.009455 43.380364 43.380364 0 0 1-32.279273-13.661091A44.776727 44.776727 0 0 1 465.454545 604.765091c0-13.893818 4.654545-24.948364 13.940364-33.210182 8.424727-8.680727 19.2-13.009455 32.279273-13.009454z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConflict);
export default __webpack_public_path__ + "static/media/conflict.169ce5325f1028ac8a0d9ef7161a906f.svg";
export { ForwardRef as ReactComponent };